var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Captcha',{ref:"captcha",attrs:{"do-if":"!skipCaptcha"},on:{"verify":_vm.verify}})
}
var staticRenderFns = []

export { render, staticRenderFns }